// src/utms/index.ts
var parseSectionUtm = ({ utm, idx, id = "", root = true }) => {
  if (!utm)
    return "";
  const prefix = root ? "?" : "&";
  return `${prefix}${utm}`.replace("{{i}}", `${idx + 1}`).replace("{{id}}", id || "");
};
var cleanSearchParam = (search) => {
  const params = new URLSearchParams(search);
  const utmParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_id",
    "wid"
  ];
  utmParams.forEach((param) => params.delete(param));
  return params;
};

export {
  parseSectionUtm,
  cleanSearchParam
};
//# sourceMappingURL=chunk-TSA53XKT.mjs.map